// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3j0Y-","overflowing":"ReadFullNote_overflowing__146mw"};